import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  MarketField,
  MarketList,
  MarketRow,
  MarketSelect,
} from '@market/react';
import { DATADOG_PRIVACY_LEVELS } from 'constants/enums';

const ControlledInputSelect = (props) => {
  const { t } = useTranslation();

  const {
    // fields used by Controller
    name,
    control,
    defaultValue,
    rules = {},
    shouldUnregister = false,

    // fields used by Market
    disabled = false,
    label,
    options,

    // config options
    shouldMaskValues = false,
  } = props;

  // small hack because `required` doesn't doesn't do a whitespace check
  if (rules?.required) {
    rules.validate = (value) => Boolean(value.trim());
  }

  // this fun looking regex ensures that the value must be one of the options or an empty string if a value is not required
  rules.pattern = new RegExp(
    `${rules?.required ? '' : '^$|'}^(${options
      .map((o) => o.value)
      .join('|')})$`,
  );

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: { value, onChange },
        fieldState: { invalid, error },
        formState: { isSubmitting, isValidating },
      }) => (
        <MarketField
          {...((disabled || isSubmitting || isValidating) && {
            disabled: true,
          })}
          name={name}
          invalid={invalid}
        >
          <MarketSelect
            value={value}
            onMarketSelectValueDidChange={(e) => onChange(e.detail.value)}
            {...(shouldMaskValues && {
              'data-dd-privacy': DATADOG_PRIVACY_LEVELS.MASK,
            })}
          >
            {label && <label>{label}</label>}
            <MarketList slot="list">
              {options.map((o) => (
                <MarketRow
                  key={o.value}
                  value={o.value}
                  {...(shouldMaskValues && {
                    'data-dd-privacy': DATADOG_PRIVACY_LEVELS.MASK,
                  })}
                >
                  {o.displayValue || o.value}
                </MarketRow>
              ))}
            </MarketList>
          </MarketSelect>
          <small slot="error">
            {error?.message || t('error.validation.invalidValue')}
          </small>
        </MarketField>
      )}
    />
  );
};

export default ControlledInputSelect;
